export enum ANALYTICS_EVENTS {
  SALE_COMPLETED = 'HubSaleCompleted',
  REGISTER_CUSTOMER_CFD = 'HubRegisterCustomerCFD',
  CONNECTION_ERROR = 'HubConnectionError',
  OPTIONS_UPDATED = 'HubOptionsUpdated',
  PRINT_COMPLETED = 'HubPrintCompleted',
  EULA_SIGNED = 'HubEulaSigned',
  NEW_BROWSER_CFD_VERSION = 'HubNewBrowserCFDVersion',
  ADD_PRINTER_BY_IP_SUCCESS = 'HubPrinterAddedByIpSuccess',
  TIP_OPTION = 'CFDTipOption',
}
